import { Component, computed, input } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { MmrService } from '../../../../../../../../../../services/mmr.service';
import { ClaimDetailsPanelViewClaim } from '../../../../../../../../../../types/mmr-claims.type';

@Component({
  selector: 'app-sp-contact-customer',
  imports: [DotPulseComponent],
  templateUrl: './sp-contact-customer.component.html',
  styleUrl: './sp-contact-customer.component.scss',
})
export class SpContactCustomerComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;

    const claim = claims.value()?.[this.claimType()] as ClaimDetailsPanelViewClaim;

    return {
      isTvRemoteReplacement: claim?.metaData?.['isTvRemoteReplacement'],
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
